<template>
    <main id="hcid-event-card-wrapper">
        <div v-if="loaderevent" class="loading loading-double"></div>
        <div v-else id="hcid-event-card-page">
            <div class="rows py-4">
            <carousel :per-page="loop" :mouse-drag="false" :navigationEnabled="true" :autoplay="true" :loop="true" navigationNextLabel='<i class="ion-chevron-right"></i>' navigationPrevLabel='<i class="ion-chevron-left"></i>'>
                <slide v-for="(data,index) in filteredEvents" :key="index">
                        <div class="card-container" >
                            <div class="card">
                                <img class="card-img-top img-card" :src="data.image_ori" alt="Card image cap">
                                <div class="card-body">
                                    <!-- <div class="row pb-2">
                                        <div class="col success" v-if="data.expired">
                                            <img :src="base_url+'/images/check.png'" alt="check" class="check-img pr-1">
                                            <span class="text-status">Selesai</span>
                                        </div>
                                        <div class="col caption" v-else>
                                            <img :src="base_url+'/images/check-grey.png'" alt="check" class="check-img pr-1">
                                            <span class="text-status">Tunggu Konfirmasi</span>
                                        </div>
                                    </div> -->
                                    <div class="row">
                                        <div class="col">
                                            <h3 class="name-card">{{data.name}}</h3>
                                        </div>
                                    </div>
                                    <!-- <div class="row">
                                        <div class="col">
                                                <span class="event-by"
                                                    >Event by <strong> {{
                                                        data.dealer
                                                            ? data.dealer
                                                            : data.author
                                                    }}</strong></span
                                                >
                                        </div>
                                    </div> -->
                                    <div class="row detail-event py-2">
                                        <div class="col">
                                            <i class="fa fa-calendar"></i> <span class="px-2">{{data.date_detail}}</span>
                                        </div>
                                    </div>
                                    <!-- <div class="row detail-event py-2">
                                        <div class="col">
                                            <i class="fa fa-location-arrow"></i> <span class="px-2">{{data.location}}</span>
                                        </div>
                                    </div> -->
                                    <div class="row py-2">
                                        <div class="col">
                                            <a @click="trackerCheckEvent(data)" :href="data.detail_url_web" class="btn btn-selengkapnya py-2">Selengkapnya</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                </slide>
            </carousel>
            </div>
        </div>
    </main>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import { Carousel, Slide } from 'vue-carousel';

export default {
    components: {
			Carousel,
			Slide
    },
    data() {
        return {
            base_url:'',
            app_url:'',
            api_url:'',
            mobile: false,
            loaderevent:true,
            events:[],
            loop: isMobile ? 1 : 3,
            msg: isMobile ? 'Welcome to Your Vue.js mobile App!' : 'Welcome to Your Vue.js App',
            isUserSimulate: false,
            user: {},
        };
    },
    created() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.checkUserSimulate();

        this.base_url = base_url;
        this.app_url = app_url;
        this.api_url = api_url;
        this.mobile = isMobile;
        this.getEvent();
    },
    computed: {
        filteredEvents() {
            return this.events.filter(data => {
                return (data.name !== 'Test Event Nasional' && data.name !== 'Test Event Regional') 
                    || (data.name === 'Test Event Nasional' && this.isUserSimulate) 
                    || (data.name === 'Test Event Regional' && this.isUserSimulate);
            });
        }
    },
    methods: {
        getEvent() {
                this.loaderevent = true;
                axios.get(api_url+'/event/upcomming')
                    .then(response => {
                        this.events = response.data.data.event;
                        this.loaderevent = false;
                    }).catch(error => {
                        console.log(error);
                    });
        },
        trackerCheckEvent(data) {
            var tracker = {
                'event': 'checkEvent',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action':'Check Event',
                'eventDetail.label': data.name,
                'eventType': data.type,
                'month': data.month || 'all',
                'province':  data.province || 'all'
            }
            dataLayer.push(tracker)
        },
        checkUserSimulate() {
            const checkHcid = process.env.MIX_HCID_PAYMENT_TEST.split(",");
            if (this.user?.hcid !== undefined) {
                const user = this.user.hcid;
                if (checkHcid.includes(user.toString())) {
                    this.isUserSimulate = true;
                } else {
                    this.isUserSimulate = false;
                }
            } else {
                this.isUserSimulate = false;
            }

            console.log('isUserSimulate = ', this.isUserSimulate);
        },
    }
};
</script>

<style scoped lang="scss">
.rows{
    margin:0 -15px;
}
#hcid-event-card-page{
    background: #000000;
    .card{
        background: #282828;
        border-radius: 10px;
        color: #FFFFFF;
    }
    .card-container{
        padding:1rem 15px;
    }
    .img-card{
        border-radius: 10px 10px 0px 0px;
    }
    .name-card{
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 30px;
        color: #FFFFFF;
    }
    .check-img{
        max-height: 18.75px;
    }

    .success{
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 22px;
        color: #7AE798
    }
    .caption{
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 22px;
        color: #B4B4B4;
    }
    .event-by{
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 22px;
        color: #4F4F4F;
    }
    .ahm{
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 22px;
    }
    .detail-event{
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 22px;
        color: #B4B4B4;
    }
    .btn-selengkapnya{
        border: 1px solid #DBDBDB;
        box-sizing: border-box;
        border-radius: 5px;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 24px;
        color: #FFFFFF;
    }
    .btn:hover{
        color: #FFFFFF;
    }
}
</style>
